import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase-config.js';

export const buscarDenunciaPorPin = httpsCallable(functions, 'buscarDenunciaPorPin');
export const enviarMensagemRelator = httpsCallable(functions, 'enviarMensagemRelator');
